<!--
  Lot – Always Display
  Head – Always Display
  Type – If available
  Avg Weight – Always Display
  Weight Range – If Available
  Price – Always Display
  Agent – If Avialable
  Paint – If Available
  Teeth – If Available
-->
<template>
  <div class="overlay">
    <h1>LOT {{ lot }}</h1>
    <table class="">
      <tbody>
        <tr>
          <th>HEAD</th>
          <td>{{ head }}</td>
        </tr>
        <tr v-if="type">
          <th>TYPE</th>
          <td>{{ type }}</td>
        </tr>
        <tr style="color:chartreuse">
          <th>AVG. WEIGHT</th>
          <td>{{ avgWeight }}</td>
        </tr>
        <tr v-if="wt_range">
          <th>WEIGHT RANGE</th>
          <td>{{ wt_range }}</td>
        </tr>
        <tr>
          <th>PRICE</th>
          <td>{{ price_per }}</td>
        </tr>
        <tr v-if="agent">
          <th>AGENT</th>
          <td>{{ agent }}</td>
        </tr>
        <tr v-if="paint">
          <th>PAINT</th>
          <td>{{ paint }}</td>
        </tr>
        <tr v-if="teeth > 0">
          <th>TEETH</th>
          <td>{{ teeth }}</td>
        </tr>
        <tr v-if="remaining > 0">
          <th>CATTLE REMAINING</th>
          <td>{{ remaining }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style>
.overlay h1 {
  font-weight: bold;
  font-size: x-large;
  padding-bottom: 1rem;
}

.overlay table {
  width: 100%;
}

.overlay table tr {
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.overlay table tr th,
td {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.overlay table tr th {
  color: white;
  font-weight: normal;
}
.overlay table tr td {
  font-weight: bold;
  text-align: right;
}
</style>

<script>
import log from 'loglevel'
import { bus } from '../common/bus'

export default {
  name: 'Stats',
  components: {},
  data() {
    return {
      lot: 0,
      head: 0,
      type: '',
      class: '',
      wt_range: '',
      avgWeight: '',
      paint: '',
      vendor: '',
      teeth: 0,
      remaining: 0,
      agent: '',
      price_per: ''
    }
  },
  mounted() {
    log.info('Stats mounted')

    let statCtx = this

    bus.$on('lotUpdate', function(payload) {
      statCtx.lot = payload.lot
      statCtx.head = payload.head
      statCtx.type = payload.type
      statCtx.class = payload.class
      statCtx.wt_range = payload.wt_range
      statCtx.avgWeight = payload.avg_weight
      statCtx.paint = payload.paint
      statCtx.vendor = payload.vendor
      statCtx.teeth = payload.teeth
      statCtx.agent = payload.agent
      statCtx.price_per = payload.price_per
      statCtx.remaining = payload.remaining
    })
  },
  destroyed() {
    bus.$off('lotUpdate')

    log.info('Stats destroyed')
  }
}
</script>
